<template>
    <div class="sa-tab-scroll">
        <b-card class="sa-card" header="Punto Incontro" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Descrizione:</label>
                    <b-form-input v-model="jsonData.descrizione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                    <label class="sa-label-data">Stato:</label>
                    <b-form-select v-model="jsonData.statoAttuale" :options="statoOptions" value-field="value" text-field="stato"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                    <label class="sa-label-data">Provincia:</label>
                    <b-form-select v-model="jsonData.provinciaSigla" :options="provinceOptions" :value="null" value-field="sigla" text-field="provincia" @change="loadProvinceChange"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                    <label class="sa-label-data">Comune:</label>
                    <b-form-select v-model="jsonData.comuneCodiceIstat" :options="comuniOptions" :value="null" value-field="codiceIstat" text-field="comune"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="9" xl="9">
                    <label class="sa-label-data">Indirizzo:</label>
                    <b-form-input v-model="jsonData.indirizzo"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3">
                    <label class="sa-label-data">Num. Civ.:</label>
                    <b-form-input v-model="jsonData.numeroCivico"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    components: {},
    mixins: [UtilityMixin],
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            showModalLoading: false,
            id: "-1",
            pathResource: "/sveipuntiincontro",
            linkProvince: "/province",
            linkComune: "/comuni/provincia",
            jsonData: {
                id: "-1",
                descrizione: "",
                provinciaSigla: null,
                comuneCodiceIstat: null,
                statoAttuale: "ATTIVO",
            },
            provinceOptions: [{ sigla: null, provincia: "-Seleziona Provincia-" }],
            comuniOptions: [{ codiceIstat: "", comune: "-Seleziona Comune-" }],
            statoOptions: [
                { value: "ATTIVO", stato: "ATTIVO" },
                { value: "SOSPESO", stato: "SOSPESO" },
                { value: "DISMESSO", stato: "DISMESSO" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadDefaultData();
    },
    methods: {
        loadDefaultData() {
            let me = this;
            me.loadProvince();
            me.loadData();
        },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            //   console.log(me.id);
            if (me.id === "-1") {
                me.showModalLoading = false;
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                me.showModalLoading = true;
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = response.data.data;
                        me.loadComuni(me.jsonData.provinciaSigla);
                        me.showModalLoading = false;
                    })
                    .catch(() => {
                        me.showModalLoading = false;
                    });
            }
        },
        loadProvince() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkProvince;
            axios.get(link).then((response) => {
                me.provinceOptions = response.data.data;
                me.provinceOptions.unshift({ sigla: null, provincia: "- Seleziona Provincia-" });
            });
        },
        loadProvinceChange(value) {
            let me = this;
            me.loadComuni(value);
            // me.provinceNascitaOptions.forEach((provincia) => {
            //     if (provincia.sigla === value) {
            //         me.setDatiIndirizzoNascita(provincia.sigla);
            //     }
            // });
        },
        // setDatiIndirizzoNascita(siglaProvincia, codiceIstatComune = null) {
        //     let me = this;
        //     me.jsonData.assistitoComuneNascita = codiceIstatComune;
        //     me.provinceNascitaOptions.forEach((provincia) => {
        //         if (provincia.sigla === siglaProvincia) {
        //             me.jsonData.assistitoProvinciaNascitaDescrizione = provincia.sigla;
        //             me.loadComuniNascita(provincia.sigla);
        //         }
        //     });
        // },
        loadComuni(sigla) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
            axios.get(link).then((response) => {
                me.comuniOptions = [];
                me.comuniOptions = response.data.data;
                me.comuniOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            });
        },
    },
};
</script>

<style></style>
